import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS } = helpers;

import { openModal } from 'actions/modal';

import Button from 'components/Button';
import Input from 'components/Input';
import ClassroomPanelListItem from './ClassroomPanelListItem';
import Plus from '../../../assets/icons/plus';
import Check from '../../../assets/icons/check';
import DeleteIcon from '../../../assets/icons/trash';

import { keyedObjToArr, setObjPath } from '../../util';

import './classroomPanelList.scss';
import '../../../sass/components/ui-list';

class ClassroomPanelList extends Component {

	constructor (props) {
		super(props);

		this.state = {
			classroom : {}
		};

	}

	updateSchoolClassrooms (school, classroomId){
		const { firebase } = this.props;
		let schoolClassroomIds = school.classrooms || {};
		schoolClassroomIds[classroomId] = true;
		firebase.set(`schools/${school.id}/classrooms`, schoolClassroomIds);
	}

	updateUserClassrooms (userId, classroomId){
		const { firebase } = this.props;
		firebase.set(`users/${userId}/classrooms/${classroomId}`, true);
	}

	addClassroom () {
		const { firebase } = this.props;
		let classroom = this.state.classroom;
		classroom.school = this.props.school.id;
		classroom.studentCount = 0;
		classroom.name = 'New Classroom';

		classroom.product = this.props.products.length > 0 ?  this.props.products[0].productId : null;

		this.setState({
			classroom : {}
		});

		firebase.push('/classrooms', classroom).then( (response)=> {
			this.updateSchoolClassrooms(this.props.school, response.key);
			this.updateUserClassrooms(classroom.teacher, response.key);
			firebase.set(`/classrooms/${response.key}/id`, response.key);
		});
	}

	deleteClassroom (classroom) {
		this.props.openModal(null, {
			message : 'Are you sure you want to delete this Classroom?',
			title : 'Delete Classroom',
				onClose : (result) => {
					if(result === true) {
						const { firebase } = this.props;
						let schoolId = classroom.school;
						let teacherId = classroom.teacher;
						firebase.remove(`/classrooms/${classroom.id}`);
						firebase.remove(`/schools/${schoolId}/classrooms/${classroom.id}`);
						firebase.remove(`/users/${teacherId}/classrooms/${classroom.id}`);
					}
				}
		});
	}


	updateClassroomStudents (classroom, event) {
		const { firebase } = this.props;
		let value = Number(event.target.value);
		firebase.set(`/classrooms/${classroom.id}/studentCount`, value);
	}

	updateSchoolName(event){
		const {firebase} = this.props;
		let value = event.target.value;
		firebase.set(`/schools/${this.props.school.id}/name`, value);
	}

	render () {
		if(!isLoaded(this.props.classrooms)) {
			return false;
		}

		//classrooms for school
		let schoolClassrooms = this.props.school && this.props.school.classrooms ? Object.keys(this.props.school.classrooms).map( (id)=> {
			let classroom = this.props.classrooms[id];
			if(classroom) {
				classroom.id = id;
			}
			return classroom;
		}).filter(function(classroom){ return classroom !== undefined; }) : [];


		let teacherOptions = this.props.customer.users ? keyedObjToArr(this.props.customer.users).filter( (user)=> {
				return this.props.users[user.id] && this.props.users[user.id].role === 'teacher';
			}).map( (user)=> {
				return {
					label : this.props.users[user.id].email,
					value : user.id
				};
		}) : [];

		let productOptions = this.props.products ? this.props.products.map( (product)=> {
			return {
				label : product.name,
				value : product.productId
			};
		}) : [];

		let schoolStudents = schoolClassrooms ? schoolClassrooms.reduce( (studentCount, classroom) => {

			if(classroom.studentCount) {
				studentCount += Number(classroom.studentCount);
			};
			return studentCount;
		}, 0) : false;

		let users = this.props.users;

		return (
			<div className="classroom-list">
				<div className="flex-grid middle school-header">
					<div className="col">
						<h4 className="title">School:</h4>
					</div>
					<div className="col wide">
						<Input
							placeholder="School Name"
							onChange={this.updateSchoolName.bind(this)}
							value={this.props.school.name}
						/>
					</div>
					<div className="col"><span className="students">{schoolStudents ? schoolStudents+ ' Students' : false}</span></div>
				</div>
				<div className="ui-list tight">
					<div className="header-container">
						<div className="list-row header" key="header">
							<div className="list-cell"><span className="data">Class</span></div>
							<div className="list-cell"><span className="data">Teacher</span></div>
							<div className="list-cell"><span className="data">Product</span></div>
							<div className="list-cell qty align-right"><span className="data">Students</span></div>
							<div className="list-cell no-grow no-left-pad"><span className="data">&nbsp;&nbsp;&nbsp;</span></div>
						</div>
					</div>
					{schoolClassrooms.map( (classroom, index)=> {
						//get teacher
						let teacher = users[classroom.teacher]

						return(<ClassroomPanelListItem
								key={index}
								classroom={classroom}
								editing={this.props.editing}
								products={this.props.products}
								teacher={teacher}
								productOptions={productOptions}
								deleteClassroom={this.deleteClassroom.bind(this)}
							/>);
					})}
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};


const fbWrappedComponent = firebaseConnect([
	//`schools#orderByChild=customer&equalTo=${this.props.customer.id}`,
	'/users',
	'/classrooms',
])(ClassroomPanelList);

export default connect(
	({ firebase }) => ({
		users: dataToJS(firebase, 'users'),
		classrooms: dataToJS(firebase, 'classrooms')
	}),
	mapDispatchToProps
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/components/ClassroomPanelList/ClassroomPanelList.js